module.exports = {
  __init__: [ 'bpmnRenderer' ],
  bpmnRenderer: [ 'type', require('./BpmnRenderer') ],
  pathMap: [ 'type', require('./PathMap') ]
};



// WEBPACK FOOTER //
// ./~/bpmn-js/lib/draw/index.js